import React from 'react';
import { Slider, Stack } from '@mui/material';
import LightbulbCircle from '@mui/icons-material/LightbulbCircle';
import LightbulbOutlined from '@mui/icons-material/LightbulbOutlined';

function ControlsComponent() {
  // const handleChange = () => {
  //
  // };
  return (
    <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
      <LightbulbOutlined></LightbulbOutlined>
      <Slider />
      <LightbulbCircle />
    </Stack>
  );
}

export default ControlsComponent;
